// Engine API: agent lifecycle (quarantine / pause / resume).
// Backed by ~/Dev/seitiate/app/api/v1/agents.py.

import { engineFetchJson } from '@/lib/engineHttp';
import type {
  AgentLifecycleBody,
  AgentLifecycleResult,
} from './agentBoardTypes';

export async function quarantineAgent(
  agentIdentityId: string,
  body: AgentLifecycleBody = {},
): Promise<AgentLifecycleResult> {
  return engineFetchJson<AgentLifecycleResult>(
    `/agents/${encodeURIComponent(agentIdentityId)}/quarantine`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}

export async function pauseAgent(
  agentIdentityId: string,
  body: AgentLifecycleBody = {},
): Promise<AgentLifecycleResult> {
  return engineFetchJson<AgentLifecycleResult>(
    `/agents/${encodeURIComponent(agentIdentityId)}/pause`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}

export async function resumeAgent(
  agentIdentityId: string,
  body: AgentLifecycleBody = {},
): Promise<AgentLifecycleResult> {
  return engineFetchJson<AgentLifecycleResult>(
    `/agents/${encodeURIComponent(agentIdentityId)}/resume`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
